import { translations } from "../translations/index.js";

/**
 * Get translated text based on the selected language
 * @param {string} path - Dot notation path to the translation (e.g., "menuItems.orders")
 * @param {string} language - Selected language code (am, ru, en)
 * @returns {string} - Translated text
 */
export const getTranslation = (path, language) => {
    try {
        // Split the path into parts
        const parts = path.split('.');
        
        // Navigate through the translations object
        let result = translations;
        for (const part of parts) {
            result = result[part];
            if (!result) {
                console.warn(`Translation not found for path: ${path}`);
                return path;
            }
        }
        
        // Return the translation for the selected language
        if (result[language]) {
            return result[language];
        } else {
            console.warn(`Translation not found for language: ${language}, path: ${path}`);
            // Fallback to Armenian if translation not found
            return result.am || path;
        }
    } catch (error) {
        console.error(`Error getting translation for path: ${path}`, error);
        return path;
    }
};

/**
 * Get the appropriate field name based on the selected language
 * @param {string} language - Selected language code (am, ru, en)
 * @returns {string} - Field name suffix (Hy, Ru, En)
 */
export const getFieldNameBySuffix = (language) => {
    switch (language) {
        case 'ru':
            return 'Ru';
        case 'en':
            return 'En';
        case 'am':
        default:
            return 'Hy';
    }
};

/**
 * Get the value from an object based on the selected language
 * @param {Object} obj - Object containing language-specific fields
 * @param {string} baseFieldName - Base field name without language suffix
 * @param {string} language - Selected language code (am, ru, en)
 * @returns {string} - Value for the selected language
 */
export const getLocalizedValue = (obj, baseFieldName, language) => {
    if (!obj) return '';
    
    const suffix = getFieldNameBySuffix(language);
    const fieldName = `${baseFieldName}${suffix}`;
    
    // Return the value for the selected language or fallback to Armenian
    return obj[fieldName] || obj[`${baseFieldName}Hy`] || '';
}; 